import _ from "lodash";

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (
  state = {
    appointments: null,
    currDuty: null,
    claims: null,
    holidays: null,
    approver: null,
    endorser: null,
    approve_req_count: null,
    endorse_req_count: null,
    req_staff_info: null,
    req_duty_info: null,
    reject_duty: null,
    select_claim: null,
  },
  action
) => {
  let newState = state;
  switch (action.type) {
    case "AUTHENTICATE-SUCCESS":
      const { appointments } = action.payload.value;
      newState = Object.assign({}, newState, {
        appointments: appointments,
      });
      break;
    case "SET-CURR-EA":
      const { approver, endorser } = action.payload.value;
      newState = Object.assign({}, newState, { approver, endorser });
      break;
    case "AUTHENTICATE-ERROR":
    case "LOGIN-ERROR":
    case "LOGOUT-SUCCESS":
      newState = {
        appointments: null,
        currDuty: null,
        claims: null,
        holidays: null,
        approver: null,
        endorser: null,
        approve_req_count: null,
        endorse_req_count: null,
        req_staff_info: null,
        req_duty_info: null,
        reject_duty: null,
        select_claim: null,
      };
      break;
    case "SET-PUBLIC-HOLIDAY":
      const { holidays } = action.payload.value;
      newState = Object.assign({}, newState, { holidays: holidays });
      break;
    case "SET-CLAIMS":
      const { CLAIMS, DUTY } = action.payload.value;
      //FIND appointment index
      const index = _.findIndex(
        newState.appointments,
        (appt) => appt.SP_DUTY_PK === DUTY.SP_DUTY_PK
      );
      let newAppts = [...newState.appointments];
      newAppts[index] = DUTY;
      newState = Object.assign({}, newState, {
        claims: CLAIMS,
        appointments: newAppts,
        currDuty: DUTY,
      });
      break;
    case "CLEAR-APPROVE-DATA":
      newState = Object.assign({}, newState, {
        req_staff_info: undefined,
        req_duty_info: undefined,
      });
      break;
    case "CLEAR-HOURLY-DATA":
    case "CLEAR-LUMPSUM-DATA":
    case "CLEAR-MONTHLY-DATA":
      newState = Object.assign({}, newState, {
        currAppt: undefined,
        currDuty: undefined,
        approver: [],
        endorser: [],
        claims: [],
        select_claim: undefined,
      });
      break;
    case "CLEAR-DUTY-INFO":
      newState = Object.assign({}, newState, {
        req_duty_info: undefined,
      });
      break;
    case "SET-REQ-DUTY-INFO":
      newState = Object.assign({}, newState, {
        req_duty_info: action.payload.value,
      });
      break;
    case "SET-REQ-STAFF-INFO":
      const { staff_info } = action.payload.value;
      newState = Object.assign({}, newState, {
        req_staff_info: staff_info,
      });
      break;
    case "GET-REQUEST-AMOUNT":
      const { approve_req_count, endorse_req_count, reject_duty } =
        action.payload.value;
      newState = Object.assign({}, newState, {
        approve_req_count: approve_req_count,
        endorse_req_count: endorse_req_count,
        reject_duty: reject_duty,
      });
      break;
    case "SELECT-CLAIM":
      const { select_claim } = action.payload.value;
      newState = Object.assign({}, newState, {
        select_claim: select_claim,
      });
      break;
    default:
      break;
  }
  return newState;
};
